import { writable } from 'svelte/store';
import { VideoService } from '@/services';
const initialState = {
    video: null,
    template: null,
    changes: [],
    isUpdated: false,
    isNew: true
};
// Init state
const { subscribe, update, set } = writable(structuredClone(initialState));
let thumbnailState;
subscribe(project => (thumbnailState = project));
let videoService = new VideoService();
const actions = {
    reset: () => {
        update(store => structuredClone(initialState));
    },
    set: (updatedState) => {
        update(store => ({ ...store, ...updatedState }));
    },
    updateTemplate: (template) => {
        update(store => {
            let temp = store.template;
            if (temp) {
                temp.content = template;
                store.template = temp;
            }
            return { ...store };
        });
    },
    async getVideo(id) {
        try {
            const videoID = !!id ? id : thumbnailState.video?.id;
            const video = await videoService.getVideo(videoID);
            update(store => {
                return {
                    ...store,
                    video
                };
            });
            return { video, error: null };
        }
        catch (error) {
            return { video: null, error: 'failed to get video' };
        }
    },
    setOriginalTemplateHTML(templateHTML) {
        update(store => ({
            ...store,
            originalTemplateHTML: templateHTML
        }));
    },
    setSnapshot(src) {
        update(store => ({
            ...store,
            snapshot: src
        }));
    },
    setPastorName(src) {
        update(store => ({
            ...store,
            pastorName: src
        }));
    },
    setType(type) {
        update(store => ({
            ...store,
            type: type
        }));
    },
    selectTemplate(selectedTemplate) {
        update(store => {
            return {
                ...store,
                template: selectedTemplate,
                originalTemplateHTML: selectedTemplate.content
            };
        });
    },
    async selectVideo(selectedVideo) {
        // Request for video to load transcript as the transcript data will not be loaded on the Choose Video page
        const video = await videoService.getVideo(selectedVideo.id);
        update(store => {
            return {
                ...store,
                video: video
            };
        });
    },
    async setVideo(fullVideo) {
        update(store => {
            return {
                ...store,
                video: fullVideo
            };
        });
        return fullVideo;
    },
    async clearChanges() {
        update(store => {
            store.changes = [];
            return store;
        });
    }
};
const thumbnail = {
    subscribe,
    update,
    ...actions
};
export default thumbnail;
